import styled from "styled-components";

export const AutoCompleteStyled = styled.div<any>`
  width: 100% !important;
  
  label {
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    color: ${({ theme, disabled }) =>
      disabled ? theme.custom?.text?.disabled || '#94a3b8' : theme.custom?.primary?.dark || '#000'};
    display: block;
    text-align: left;
    margin-bottom: 8px !important;
    span {
      color: red;
    }
  }
  position: relative;
  
  .MuiAutocomplete-root {
    width: 100%;
  }
  
  .MuiTextField-root {
    width: 100%;
  }
`;
